import React, {useContext, useEffect, useRef, useState} from 'react';
import {DeleteItemDialog} from '../components/dialogs/DeleteDialog/DeleteItemDialog';
import {FileDetailsDialog} from '../components/dialogs/FileDetailsDialog/FileDetailsDialog';
import {NumericValue, StringArrayValue, StringValue, useQueryParam} from '../hooks/UseQuerryParam';
import {Dialog, Layout} from '@bosch/react-frok';
import {SearchBar} from '../components/SearchBar/SearchBar';
import {CreateEditFolderDialog} from '../components/dialogs/CreateEditFolderDialog/CreateEditFolderDialog';
import {AddItemMenu} from '../components/AddItemMenu/AddItemMenu';
import {FolderDetailsDialog} from '../components/dialogs/FolderDetailsDialog/FolderDetailsDialog';
import {StorageObject} from '../models/StorageObject';
import {UploadFileDialog} from '../components/dialogs/UploadFileDialog/UploadFileDialog';
import {t} from 'i18next';
import {
    LENGTH_LIMIT_URL_QUERY_PARAMETER,
    NO_DISCLAIMER_KEY,
    PARAM_FILE_ID,
    PARAM_FILE_TYPES,
    PARAM_IS_FAVORITE,
    PARAM_IS_PUBLIC,
    PARAM_LAYOUT,
    PARAM_ORDER,
    PARAM_PAGE,
    PARAM_PAGE_SIZE,
    PARAM_PATH,
    PARAM_RECENTLY_ADDED,
    PARAM_SEARCH,
    PARAM_SHOW_ITEM_DETAILS,
    PARAM_SHOW_ITEM_PREVIEW,
    PARAM_SORT,
    PARAM_TYPE,
    WATERMARK,
} from '../init/constants';
import {useDeleteItem} from '../hooks/UseDeleteItem';
import {useCreateFolder} from '../hooks/UseCreateFolder';
import {useUploadFile} from '../hooks/UseUploadFile';
import {useEditFolder} from '../hooks/UseEditFolder';
import {useEditFile} from '../hooks/UseEditFile';
import {useGetSearchResult} from '../hooks/UseGetSearchResult';
import {EditFileDialog} from '../components/dialogs/UploadFileDialog/EditFileDialog';
import {AuthContext} from '../context/AuthContext';
import {LocaleContext} from '../context/LocaleContext';
import {useDownloadFile} from '../hooks/UseDownloadFile';
import {ItemsFooter} from '../components/itemVisualisation/ItemsFooter/ItemsFooter';
import {ItemsHeader} from '../components/itemVisualisation/ItemsHeader/ItemsHeader';
import {config} from '../init/config';
import {ErrorHint} from '../components/errors/ErrorHint';
import {LoadingIndicator} from '../components/LoadingIndicator/LoadingIndicator';
import {ItemsViewWrapper} from '../components/itemVisualisation/ItemsViewWrapper.style';
import {Breadcrumb, BreadcrumbPaths} from '../components/Breadcrumb/Breadcrumb';
import {
    UploadProgressIndicator,
    uploadProgressIndicatorId
} from '../components/UploadProgressIndicator/UploadProgressIndicator';
import {BreadcrumbsDTO} from '../models/dto/BreadcrumbsDTO';
import {
    convertLocaleToPersistentValue,
    convertToSearchFilterPredefined,
    convertToStringArray,
    createLocale,
    createSearchFilterPredefined,
    getBreadcrumbState,
    isNullOrEmpty,
    isPredefinedFilterApplicable,
    isTrue,
    isWatermarkApplicableCheck,
    validateSearchTerm,
    validateSortOrder
} from '../utils';
import {useSearchParams} from 'react-router-dom';
import {DownloadFileDialog} from '../components/dialogs/DownloadFileDialog/DownloadFileDialog';
import {useGetDisclaimerData} from '../hooks/UseGetDisclaimerData';
import {DisclaimerDTO} from '../models/dto/DisclaimerDTO';
import {useMarkAsFavorite} from '../hooks/UseMarkAsFavorite';
import {useGetLabelData} from '../hooks/UseGetLabelData';
import {ValidationMessage} from '../models/ValidationMessage';
import {
    getCreateFolderDTO,
    getEditFileDTO,
    getEditFolderDTO,
    getLayoutTypeByKey,
    getUploadFileDTO
} from '../utils/DtoUtils';
import {createRoleName, hasEditorialAccess, hasPublicOnlyAccess} from '../utils/UserUtils';
import {ItemsView} from '../components/itemVisualisation/ItemsView';
import {NotificationType} from '../models/NotificationType';
import {
    getErrorDataValidationMessages,
    getGeneralErrorErrorMessage,
    getNoDataFoundErrorMessage,
    getSearchTermConstraintErrorMessage,
    getUrlLengthLimitConstraintErrorMessage
} from '../components/errors/ErrorRegister';
import {ErrorDialogue, setErrorDescription} from '../components/errors/ErrorDialogue';
import {useGiveConsent} from '../hooks/UseGiveConsent';
import {PreviewDialog} from '../components/dialogs/PreviewDialog/PreviewDialog';
import {generateIdentifier} from '../utils/IdentityUtils';
import {getLabelEntryMapDefault, getLabelNative, isFile} from '../utils/StorageObjectUtils';
import {useGetUiCombinedTemplates} from '../hooks/UseGetUiCombinedTemplates';
import {
    getApplicableTemplateUiConfigurationPropertySettingsMap,
    getDefaultValueOfComponent,
    getEmptyTemplatePropertySettingsMap,
    getStorageObjectTemplates,
    getUiConfigurationTemplates,
    isActiveComponent,
    isVisibleComponent
} from '../utils/TemplateUtils';
import {TemplatePropertySettings} from '../models/TemplatePropertySettings';
import {
    DOWNLOAD_CENTER_BREADCRUMB,
    DOWNLOAD_CENTER_ITEMS_FOOTER,
    DOWNLOAD_CENTER_ITEMS_HEADER,
    DOWNLOAD_CENTER_ITEMS_VIEW,
    DOWNLOAD_CENTER_MAIN_ACTION,
    DOWNLOAD_CENTER_MOBILE_BREADCRUMB,
    DOWNLOAD_CENTER_MOBILE_ITEMS_FOOTER,
    DOWNLOAD_CENTER_MOBILE_ITEMS_HEADER,
    DOWNLOAD_CENTER_MOBILE_ITEMS_VIEW,
    DOWNLOAD_CENTER_MOBILE_MAIN_ACTION,
    DOWNLOAD_CENTER_SEARCH_PAGE_SIZE_OPTIONS,
    DOWNLOAD_CENTER_SEARCH_PARAMETER_PAGE_SIZE,
    DOWNLOAD_CENTER_SEARCH_PARAMETER_RECENTLY_ADDED,
    DOWNLOAD_CENTER_SEARCH_PARAMETER_SORT_ORDER,
    DOWNLOAD_CENTER_SEARCH_PARAMETER_SORT_TYPE,
    ITEMS_HEADER_LAYOUT,
    ITEMS_HEADER_MOBILE_LAYOUT,
    ITEMS_VIEW_COMMAND_ACTION_COPY_URL,
    ITEMS_VIEW_COMMAND_ACTION_DELETE,
    ITEMS_VIEW_COMMAND_ACTION_DOWNLOAD,
    ITEMS_VIEW_COMMAND_ACTION_EDIT,
    ITEMS_VIEW_COMMAND_ACTION_FAVORITE,
    ITEMS_VIEW_COMMAND_ACTION_NAVIGATE,
    ITEMS_VIEW_COMMAND_ACTION_PREVIEW,
    ITEMS_VIEW_COMMAND_ACTION_VIEW,
    ITEMS_VIEW_FILE_ON_CLICK_COMMAND_ACTION,
    ITEMS_VIEW_FOLDER_ON_CLICK_COMMAND_ACTION,
    ITEMS_VIEW_MOBILE_FILE_ON_CLICK_COMMAND_ACTION,
    ITEMS_VIEW_MOBILE_FOLDER_ON_CLICK_COMMAND_ACTION,
    MAIN_FILTERS,
    PREDEFINED_FILTERS,
    SEARCH_BAR,
    SEARCH_BAR_MOBILE,
    SUB_FILTERS
} from '../init/ui_component_constants';
import {useIsMobileResolution} from '../hooks/UseIsMobileResolution';
import {LayoutViewType} from '../models/LayoutViewType';
import {ObjectType} from '../models/ObjectType';
import {
    API_TOKEN_PATH,
    COSMOS_DATABASE_SPACE_NAME,
    DISCLAIMER_ENABLED,
    DISCLAIMER_URL,
    DLS_BACKEND_URL,
    DLS_ROLE_LENGTH,
    DLS_TENANT,
    LABEL_ENABLED,
    LABEL_URL,
    LANGUAGE_ONLY_MODE,
    LOCALE_COUNTRIES,
    LOCALE_COUNTRY_DEFAULT,
    LOCALE_LANGUAGE_DEFAULT,
    LOCALE_LANGUAGES,
    PERMISSIONS,
    ROLE_ACCESS_MOBILE_VIEW_ADMIN,
    ROLE_ACCESS_MOBILE_VIEW_EDITOR,
    ROLE_ACCESS_MOBILE_VIEW_USER,
    ROLE_ADMIN,
    ROLE_EDITOR,
    ROLE_USER,
    STYLE_WORD_BREAK,
    SWAP_COUNTRY_LANGUAGE,
    THUMBNAIL_UPLOAD_MAX_SIZE,
    UI_INCLUIDE_FROK,
    USE_CLIENT_ROLES,
    WTM_BACKEND_URL
} from '../init/ui_configuration';
import {
    defaultDownloadCenterSearchPageSizeOptions,
    defaultDownloadCenterSearchParameterPageSize,
    defaultDownloadCenterSearchParameterRecentlyAdded,
    defaultDownloadCenterSearchParameterSortOrder,
    defaultDownloadCenterSearchParameterSortType,
    defaultItemsHeaderLayout,
    defaultItemsHeaderMobileLayout,
    defaultItemsViewFileOnClickCommandAction,
    defaultItemsViewFolderOnClickCommandAction,
    defaultItemsViewMobileFileOnClickCommandAction,
    defaultItemsViewMobileFolderOnClickCommandAction
} from '../init/ui_component_defaults';
import {TYPE_ALL} from '../utils/DropdownOptionPropsUtils';
import {DropdownOptionProps} from '../models/DropdownProps';
import {countryResource} from '../components/LocalePicker/resources/CountryResource';
import {languageResource} from '../components/LocalePicker/resources/LanguageResource';

const initializeDynamicConfig = (isTemplatesInitialized: boolean, templatePropertySettings: Map<string, TemplatePropertySettings>) => {
    if ((isTemplatesInitialized) || (!templatePropertySettings) || (templatePropertySettings.size === 0)) {
        return;
    }

    let dlsBackendUrlDefault = getDefaultValueOfComponent(DLS_BACKEND_URL, templatePropertySettings);
    if (!isNullOrEmpty(dlsBackendUrlDefault)) {
        config.DLS_BACKEND_URL = dlsBackendUrlDefault;
    }

    let tenantDefault = getDefaultValueOfComponent(DLS_TENANT, templatePropertySettings);
    if (!isNullOrEmpty(tenantDefault)) {
        config.DLS_TENANT = tenantDefault;
    }

    config.WTM_ENABLED = isActiveComponent(WTM_BACKEND_URL, templatePropertySettings);
    let wtmBackendUrlDefault = getDefaultValueOfComponent(WTM_BACKEND_URL, templatePropertySettings);
    if (!isNullOrEmpty(wtmBackendUrlDefault)) {
        config.WTM_BACKEND_URL = wtmBackendUrlDefault;
    }

    config.DISCLAIMER_ENABLED = isActiveComponent(DISCLAIMER_ENABLED, templatePropertySettings);
    let dlsDisclaimerUrlDefault = getDefaultValueOfComponent(DISCLAIMER_URL, templatePropertySettings);
    if (!isNullOrEmpty(dlsDisclaimerUrlDefault)) {
        config.DISCLAIMER_URL = dlsDisclaimerUrlDefault;
    }

    config.LABEL_ENABLED = isActiveComponent(LABEL_ENABLED, templatePropertySettings);
    let dlsLabelUrlDefault = getDefaultValueOfComponent(LABEL_URL, templatePropertySettings);
    if (!isNullOrEmpty(dlsLabelUrlDefault)) {
        config.LABEL_URL = dlsLabelUrlDefault;
    }

    if (!isNullOrEmpty(getDefaultValueOfComponent(UI_INCLUIDE_FROK, templatePropertySettings))) {
        config.DLS_DOWNLOAD_INCLUDE_FROK = isActiveComponent(UI_INCLUIDE_FROK, templatePropertySettings);
    }

    if (!isNullOrEmpty(getDefaultValueOfComponent(THUMBNAIL_UPLOAD_MAX_SIZE, templatePropertySettings))) {
        let thumbnailUploadMaxSizesDefault = Number(getDefaultValueOfComponent(THUMBNAIL_UPLOAD_MAX_SIZE, templatePropertySettings));
        if ((thumbnailUploadMaxSizesDefault !== undefined) && thumbnailUploadMaxSizesDefault && (!isNaN(thumbnailUploadMaxSizesDefault)) && (thumbnailUploadMaxSizesDefault > 0)) {
            config.DLS_THUMBNAIL_MAX_SIZE = thumbnailUploadMaxSizesDefault;
        }
    }

    if (!isNullOrEmpty(getDefaultValueOfComponent(STYLE_WORD_BREAK, templatePropertySettings))) {
        config.DLS_WORD_BREAK = isActiveComponent(STYLE_WORD_BREAK, templatePropertySettings);
    }

    let apiTokenPathDefault = getDefaultValueOfComponent(API_TOKEN_PATH, templatePropertySettings);
    if (!isNullOrEmpty(apiTokenPathDefault)) {
        config.DLS_API_TOKEN_PATH = apiTokenPathDefault;
    }

    if (!isNullOrEmpty(getDefaultValueOfComponent(USE_CLIENT_ROLES, templatePropertySettings))) {
        config.DLS_USE_CLIENT_ROLES = isTrue(getDefaultValueOfComponent(USE_CLIENT_ROLES, templatePropertySettings));
    }

    if (!isNullOrEmpty(getDefaultValueOfComponent(DLS_ROLE_LENGTH, templatePropertySettings))) {
        let roleMaxLength = Number(getDefaultValueOfComponent(DLS_ROLE_LENGTH, templatePropertySettings));
        if ((roleMaxLength !== undefined) && roleMaxLength && (!isNaN(roleMaxLength)) && (roleMaxLength > 0)) {
            config.DLS_ROLE_LENGTH = roleMaxLength;
        }
    }

    let permissionsDefault = convertToStringArray([getDefaultValueOfComponent(PERMISSIONS, templatePropertySettings)])
        .map(language => language.toUpperCase());
    if (permissionsDefault.length > 0) {
        config.PERMISSIONS = permissionsDefault;
    }

    config.DLS_ADMIN_ROLE_NAME = createRoleName(getDefaultValueOfComponent(ROLE_ADMIN, templatePropertySettings));
    config.DLS_EDITOR_ROLE_NAME = createRoleName(getDefaultValueOfComponent(ROLE_EDITOR, templatePropertySettings));
    config.DLS_USER_ROLE_NAME = createRoleName(getDefaultValueOfComponent(ROLE_USER, templatePropertySettings));

    let spaceNameDefault = getDefaultValueOfComponent(COSMOS_DATABASE_SPACE_NAME, templatePropertySettings);
    if (!isNullOrEmpty(spaceNameDefault)) {
        config.DLS_SPACE_NAME = spaceNameDefault;
    }

    let languageOnlyModeDefault = getDefaultValueOfComponent(LANGUAGE_ONLY_MODE, templatePropertySettings);
    if (!isNullOrEmpty(languageOnlyModeDefault)) {
        config.LANGUAGE_ONLY_MODE_ACTIVE = isTrue(languageOnlyModeDefault);
    }

    let swapCountryLanguageDefault = getDefaultValueOfComponent(SWAP_COUNTRY_LANGUAGE, templatePropertySettings);
    if (!isNullOrEmpty(swapCountryLanguageDefault)) {
        config.LANGUAGE_ONLY_MODE_ACTIVE = isTrue(swapCountryLanguageDefault);
    }

    let countryDefault = getDefaultValueOfComponent(LOCALE_COUNTRY_DEFAULT, templatePropertySettings).toLowerCase();
    if (!isNullOrEmpty(countryDefault)) {
        config.DLS_COUNTRY_DEFAULT = countryDefault;
    }

    let languageDefault = getDefaultValueOfComponent(LOCALE_LANGUAGE_DEFAULT, templatePropertySettings).toLowerCase();
    if (!isNullOrEmpty(countryDefault)) {
        config.DLS_LANGUAGE_DEFAULT = languageDefault;
    }

    let countriesDefault = convertToStringArray([getDefaultValueOfComponent(LOCALE_COUNTRIES, templatePropertySettings)])
        .map(country => country.toUpperCase());
    if (countriesDefault.length > 0) {
        config.DLS_COUNTRIES = countriesDefault;
    }

    let languagesDefault = convertToStringArray([getDefaultValueOfComponent(LOCALE_LANGUAGES, templatePropertySettings)])
        .map(language => language.toLowerCase());
    if (languagesDefault.length > 0) {
        config.DLS_LANGUAGES = languagesDefault;
    }

    let mainFiltersDefault = convertToStringArray([getDefaultValueOfComponent(MAIN_FILTERS, templatePropertySettings)]);
    if (mainFiltersDefault.length > 0) {
        config.MAIN_FILTERS = mainFiltersDefault;
    }

    let subFiltersDefault = convertToStringArray([getDefaultValueOfComponent(SUB_FILTERS, templatePropertySettings)]);
    if (subFiltersDefault.length > 0) {
        config.SUB_FILTERS = subFiltersDefault;
    }

    let predefinedFiltersDefault = getDefaultValueOfComponent(PREDEFINED_FILTERS, templatePropertySettings);
    if ((!isNullOrEmpty(predefinedFiltersDefault) && ('{}' !== predefinedFiltersDefault))) {
        config.PREDEFINED_FILTERS = convertToSearchFilterPredefined(predefinedFiltersDefault);
    }
}

/**
 * @name DownloadCenter
 * @description
 * Main component of the download center that connects all components and its business logic
 */
declare const window: Window & { dataLayer: Record<string, unknown>[]; };
export const DownloadCenter: React.VFC = () => {
    const [showItemDetails, setShowItemDetails] = useQueryParam(PARAM_SHOW_ITEM_DETAILS, {
        paramType: StringValue,
        defaultValue: null,
        replaceNavigation: false
    });

    const [showPreview, setShowPreview] = useQueryParam(PARAM_SHOW_ITEM_PREVIEW, {
        paramType: StringValue,
        defaultValue: null,
        replaceNavigation: false
    });

    const [fileId, setFileId] = useQueryParam(PARAM_FILE_ID, {
        paramType: StringValue,
        defaultValue: null,
        replaceNavigation: true
    });

    const [path, setPath] = useQueryParam(PARAM_PATH, {
        paramType: StringValue,
        defaultValue: '/',
        replaceNavigation: true
    });

    const [page, setPage] = useQueryParam(PARAM_PAGE, {
        paramType: NumericValue,
        defaultValue: 1,
        replaceNavigation: true
    });

    const [pageSize, setPageSize] = useQueryParam(PARAM_PAGE_SIZE, {
        paramType: NumericValue,
        defaultValue: 0,
        replaceNavigation: true
    });

    const [sortType, setSortType] = useQueryParam(PARAM_SORT, {
        paramType: StringValue,
        defaultValue: '',
        replaceNavigation: true
    });

    const [sortOrder, setSortOrder] = useQueryParam(PARAM_ORDER, {
        paramType: StringValue,
        defaultValue: '',
        replaceNavigation: true
    });

    const [layoutView, setLayoutView] = useQueryParam(PARAM_LAYOUT, {
        paramType: StringValue,
        defaultValue: '',
        replaceNavigation: true
    });

    const [searchTerm, setSearchTerm] = useQueryParam(PARAM_SEARCH, {
        paramType: StringValue,
        defaultValue: null,
        replaceNavigation: true
    });

    const [fileTypes, setFileTypes] = useQueryParam(PARAM_FILE_TYPES, {
        paramType: StringArrayValue,
        defaultValue: null,
        replaceNavigation: true
    });

    const [noOfDays, setNoOfDays] = useQueryParam(PARAM_RECENTLY_ADDED, {
        paramType: NumericValue,
        defaultValue: 0,
        replaceNavigation: true
    });

    const [isFavorite, setIsFavorite] = useQueryParam(PARAM_IS_FAVORITE, {
        paramType: StringValue,
        defaultValue: 'false',
        replaceNavigation: true
    });

    const [isPublic, setIsPublic] = useQueryParam(PARAM_IS_PUBLIC, {
        paramType: StringValue,
        defaultValue: 'false',
        replaceNavigation: true
    });

    const [objectType, setObjectType] = useQueryParam(PARAM_TYPE, {
        paramType: StringValue,
        defaultValue: null,
        replaceNavigation: true
    });

    // UI template settings initialization. StorageObjects template settings are much broader and data dependent.
    // StorageObjects template settings include the UI template settings by requirement.
    const [templatePropertySettings, setTemplatePropertySettings] = useState<Map<string, TemplatePropertySettings>>(getEmptyTemplatePropertySettingsMap());
    const [isTemplatesInitialized, setIsTemplatesInitialized] = useState<boolean>(false);
    const {isAuthenticated, roles, isAuthenticating} = useContext(AuthContext);
    const [editMode, setEditMode] = useState<boolean>(false);
    const [publicOnlyAccess, setPublicOnlyAccess] = useState<boolean>(false);
    const {language, country} = useContext(LocaleContext);
    const [defaultLocale, setDefaultLocale] = useState<string>(createLocale(language, country));

    const setProgress = (progress: number) => {
        const progressIndicator = document.querySelector<HTMLElement>(`.${uploadProgressIndicatorId} div`);
        if (progressIndicator) {
            const oldProgressValue = progressIndicator.style.width;
            const newProgressValue = `${parseInt(progress.toString())}%`;

            if (newProgressValue !== oldProgressValue) {
                progressIndicator.style.width = newProgressValue;
            }
        }
    };

    const {
        headlessDeleteAction,
        itemToDelete,
        setItemToDelete,
        countriesToDelete,
        setCountriesToDelete,
        languagesToDelete,
        setLanguagesToDelete,
        localesToDelete,
        setLocalesToDelete,
        isCompleteToDelete,
        setIsCompleteToDelete,
        deleteItem,
        cancelDeleteItem
    } = useDeleteItem();

    const {createFolderModeActive, setCreateFolderModeActive, createFolder} = useCreateFolder();
    const {folderToEdit, setFolderToEdit, editFolder} = useEditFolder();
    const {fileToEdit, setFileToEdit, editFile} = useEditFile();
    const [showProgressDialog, setShowProgressDialog] = useState<boolean>(false);
    const {
        uploadFileModeActive,
        setUploadFileModeActive,
        uploadFile,
        isLoading: uploadInProgress
    } = useUploadFile(setProgress);

    useEffect(() => {
        setShowProgressDialog(uploadInProgress);
    }, [uploadInProgress]);

    const {giveConsent} = useGiveConsent();
    // const {revokeConsent} = useRevokeConsent();

    const {fileToDownload, setFileToDownload, downloadFile} = useDownloadFile();

    const {markAsFavorite} = useMarkAsFavorite();

    const getIsFavorite = (): boolean => {
        return hasPublicOnlyAccess(isAuthenticated, roles) ? false : isTrue(isFavorite);
    };

    const getIsPublic = (): boolean => {
        return hasPublicOnlyAccess(isAuthenticated, roles) ? false : isTrue(isPublic);
    };

    const [breadcrumbs, setBreadcrumbs] = useState<BreadcrumbsDTO[]>([]);
    const [breadcrumbPath, setBreadcrumbPath] = useState<BreadcrumbPaths>(BreadcrumbPaths.HOME);
    const setUiCombinedTemplates = useGetUiCombinedTemplates();

    useEffect(() => {
        if (isTemplatesInitialized) {
            return;
        }

        setUiCombinedTemplates(true)
            .then(uiCombinedTemplates => {
                if (uiCombinedTemplates) {
                    config.DLS_UI_CONFIGURATION_TEMPLATES = getUiConfigurationTemplates(uiCombinedTemplates);
                    config.DLS_STORAGE_OBJECT_TEMPLATES = getStorageObjectTemplates(uiCombinedTemplates);
                }
            }).then(() => setTemplatePropertySettings(getApplicableTemplateUiConfigurationPropertySettingsMap()));
    }, [isTemplatesInitialized]);

    // User choice prevent the policy to apply mobile view on initial page landing
    const [userLayoutView, setUserLayoutView] = useState<LayoutViewType>();
    // MobileView initialize
    const isMobileResolution = useIsMobileResolution();
    const [desktopLayoutView, setDesktopLayoutView] = useState<LayoutViewType>(getLayoutTypeByKey(defaultItemsHeaderLayout));
    //Initial MobileView State is equal to Default Desktop LayoutView
    const [mobileLayoutView, setMobileLayoutView] = useState<LayoutViewType>(getLayoutTypeByKey(defaultItemsHeaderMobileLayout));
    const [isMobileView, setIsMobileView] = useState<boolean>(isMobileResolution);
    const [searchParams, setSearchParams] = useSearchParams();
    const [sortTypeDefault, setSortTypeDefault] = useState<string>(defaultDownloadCenterSearchParameterSortType);
    const [sortOderDefault, setSortOrderDefault] = useState<string>(defaultDownloadCenterSearchParameterSortOrder);
    const [recentlyAddedDefault, setRecentlyAddedDefault] = useState<number>(defaultDownloadCenterSearchParameterRecentlyAdded);
    const [defaultPageSize, setDefaultPageSize] = useState(defaultDownloadCenterSearchParameterPageSize);
    const [pageSizeDataSource, setPageSizeDataSource] = useState<string[]>(defaultDownloadCenterSearchPageSizeOptions);

    const initializeSearchParameters = (isTemplatesInitialized: boolean, templatePropertySettings: Map<string, TemplatePropertySettings>) => {
        if ((isTemplatesInitialized) || (!templatePropertySettings) || (templatePropertySettings.size === 0)) {
            return;
        }

        let pageSizeDefault = Number(getDefaultValueOfComponent(DOWNLOAD_CENTER_SEARCH_PARAMETER_PAGE_SIZE, templatePropertySettings));
        if ((pageSizeDefault !== undefined) && pageSizeDefault && (!isNaN(pageSizeDefault)) && (pageSizeDefault > 0)) {
            setDefaultPageSize(pageSizeDefault);
        }

        if (pageSize < 1) {
            setPageSize(pageSizeDefault);
        }

        let pageSizeOptionsDefault = convertToStringArray([getDefaultValueOfComponent(DOWNLOAD_CENTER_SEARCH_PAGE_SIZE_OPTIONS, templatePropertySettings)]);
        if (pageSizeOptionsDefault.length > 0) {
            if (!pageSizeOptionsDefault.includes(pageSizeDefault.toString())) {
                pageSizeOptionsDefault.push(pageSizeDefault.toString());
            }

            setPageSizeDataSource(pageSizeOptionsDefault);
        } else if (config.NO_OF_ITEMS.length > 0) {
            pageSizeOptionsDefault = [...config.NO_OF_ITEMS];
            if (!config.NO_OF_ITEMS.includes(pageSizeDefault.toString())) {
                pageSizeOptionsDefault.push(pageSizeDefault.toString());
            }

            setPageSizeDataSource(pageSizeOptionsDefault);
        }

        let defaultSortType = getDefaultValueOfComponent(DOWNLOAD_CENTER_SEARCH_PARAMETER_SORT_TYPE, templatePropertySettings).toLowerCase();
        if (isNullOrEmpty(defaultSortType)) {
            defaultSortType = defaultDownloadCenterSearchParameterSortType;
        }

        if (defaultSortType !== sortTypeDefault) {
            setSortTypeDefault(defaultSortType);
        }

        if ((isNullOrEmpty(sortType)) && (defaultSortType !== sortType)) {
            setSortType(defaultSortType);
        }

        let defaultSortOrder = getDefaultValueOfComponent(DOWNLOAD_CENTER_SEARCH_PARAMETER_SORT_ORDER, templatePropertySettings).toLowerCase();
        if (isNullOrEmpty(defaultSortOrder)) {
            defaultSortOrder = defaultDownloadCenterSearchParameterSortOrder;
        }

        if (defaultSortOrder !== sortOderDefault) {
            setSortOrderDefault(defaultSortOrder);
        }

        if ((isNullOrEmpty(sortOrder)) && (defaultSortOrder !== sortOrder)) {
            setSortOrder(defaultSortOrder);
        }

        let recentlyAddedDaysDefault = Number(getDefaultValueOfComponent(DOWNLOAD_CENTER_SEARCH_PARAMETER_RECENTLY_ADDED, templatePropertySettings));
        if ((recentlyAddedDaysDefault !== undefined) && recentlyAddedDaysDefault && (!isNaN(recentlyAddedDaysDefault)) && (recentlyAddedDaysDefault > 0)) {
            setRecentlyAddedDefault(recentlyAddedDaysDefault);
        } else if (config.NO_OF_RECENT_DAYS > 0) {
            setRecentlyAddedDefault(config.NO_OF_RECENT_DAYS);
        }
    }

    const initializeView = (isTemplatesInitialized: boolean, templatePropertySettings: Map<string, TemplatePropertySettings>) => {
        if ((isTemplatesInitialized) || (!templatePropertySettings) || (templatePropertySettings.size === 0)) {
            return;
        }

        let defaultLayoutView = getDefaultValueOfComponent(ITEMS_HEADER_LAYOUT, templatePropertySettings).toLowerCase();
        if (!isNullOrEmpty(defaultLayoutView)) {
            defaultLayoutView = defaultItemsHeaderLayout;
        } else {
            defaultLayoutView = config.DLS_LAYOUT;
        }

        if (defaultLayoutView !== desktopLayoutView) {
            setDesktopLayoutView(getLayoutTypeByKey(defaultLayoutView));
        }

        let defaultMobileLayoutView = getDefaultValueOfComponent(ITEMS_HEADER_MOBILE_LAYOUT, templatePropertySettings).toLowerCase();
        if (isNullOrEmpty(defaultMobileLayoutView)) {
            defaultMobileLayoutView = defaultItemsHeaderMobileLayout;
        }

        if (defaultMobileLayoutView !== mobileLayoutView) {
            setMobileLayoutView(getLayoutTypeByKey(defaultMobileLayoutView));
        }
    }

    // UI Configuration from templates
    useEffect(() => {
        if ((isTemplatesInitialized) || (!templatePropertySettings) || (templatePropertySettings.size === 0)) {
            return;
        }

        initializeDynamicConfig(isTemplatesInitialized, templatePropertySettings);
        initializeSearchParameters(isTemplatesInitialized, templatePropertySettings);
        initializeView(isTemplatesInitialized, templatePropertySettings);
        setIsTemplatesInitialized(true);
    }, [isTemplatesInitialized, templatePropertySettings]);

    useEffect(() => {
        if (!isTemplatesInitialized) {
            return;
        }

        setDefaultLocale(createLocale(language, country));
    }, [isTemplatesInitialized, language, country]);

    // We hold permissions state as an option to direct integration with authorization system like Keycloak
    const [roleDataSource] = useState<string[]>(config.PERMISSIONS.sort());
    const [parentOwnerRoles, setParentOwnerRoles] = useState<string[]>([]);
    const [parentRoles, setParentRoles] = useState<string[]>([]);
    const [parentLocales, setParentLocales] = useState<string[]>([]);
    const [disclaimerOptions, setDisclaimerOptions] = useState<DisclaimerDTO[]>([]);
    const [disclaimerDialog, setDisclaimerDialog] = useState<boolean>(false);
    const [disclaimerWatermarkDialog, setDisclaimerWatermarkDialog] = useState<boolean>(false);
    const [storageObjects, setStorageObjects] = useState<StorageObject[]>([]);
    const [favoritesStorageObjects, setFavoritesStorageObjects] = useState<string[]>([]);
    const [pageCount, setPageCount] = useState(0);
    const [itemCountTotal, setItemCountTotal] = useState(0);
    const [populateError, setPopulateError] = useState<boolean>(false);
    const [dialogError, setDialogError] = useState<Partial<{ headline?: string, errorDescription?: string }>>();
    const layoutRef = useRef<HTMLDivElement>(null);

    // Sets in centralized way the permissions settings
    useEffect(() => {
        setEditMode(hasEditorialAccess(isAuthenticated, roles));
        setPublicOnlyAccess(hasPublicOnlyAccess(isAuthenticated, roles));
    }, [isTemplatesInitialized, isAuthenticated, roles]);

    useEffect(() => {
        if ((fileId !== undefined) && fileId) {
            setShowItemDetails(fileId);
        }
    }, [fileId]);

    // Sets in centralized way the Mobile View settings
    useEffect(() => {
        if (!isTemplatesInitialized) {
            return;
        }

        let isMobileViewApplicable = isMobileResolution
            && ((publicOnlyAccess && isVisibleComponent(ROLE_ACCESS_MOBILE_VIEW_USER, templatePropertySettings))
                || (editMode && (isVisibleComponent(ROLE_ACCESS_MOBILE_VIEW_EDITOR, templatePropertySettings)
                    || isVisibleComponent(ROLE_ACCESS_MOBILE_VIEW_ADMIN, templatePropertySettings))));

        setIsMobileView(isMobileViewApplicable);
        if (isMobileViewApplicable) {
            if ((userLayoutView !== undefined) && userLayoutView) {
                setLayoutView(userLayoutView);
                return;
            }

            setLayoutView(mobileLayoutView);
            return;
        }

        if ((userLayoutView !== undefined) && userLayoutView) {
            setLayoutView(userLayoutView);
            return;
        }

        if (isMobileResolution) {
            setLayoutView(mobileLayoutView);
            return;
        }

        setLayoutView(desktopLayoutView);
    }, [isTemplatesInitialized, isMobileResolution, editMode, desktopLayoutView, mobileLayoutView, userLayoutView]);

    const handleLayoutViewChange = (userLayout?: LayoutViewType) => {
        if ((userLayout !== undefined) && userLayout) {
            setUserLayoutView(userLayout);
            setLayoutView(userLayout);
        }
    };

    // Sets the default mandatory query parameters to url
    useEffect(() => {
        if (!isTemplatesInitialized) {
            return;
        }

        let pathValue = decodeURI(path);
        if ((path === '/') || (path !== pathValue)) {
            setPath(pathValue);
        }

        if (page < 1) {
            setPage(1);
        }

        if (pageSize < 1) {
            setPageSize(defaultPageSize);
        }

        if (!isNullOrEmpty(sortType)) {
            setSortType(sortType.toLowerCase());
        }

        if (!isNullOrEmpty(sortOrder)) {
            setSortOrder(sortOrder.toLowerCase());
        }

        handleLayoutViewChange(userLayoutView);
        setPopulateError(true);
    }, [isTemplatesInitialized, path, page, pageSize, sortType, sortOrder, userLayoutView]);

    useEffect(() => {
        if (!isTemplatesInitialized) {
            return;
        }

        // Sets predefined query parameters to url only once on mount
        let predefinedFilters = config.PREDEFINED_FILTERS;
        let searchFilterState = createSearchFilterPredefined(searchTerm, fileTypes, objectType);
        if ((path === '/') && (!isPredefinedFilterApplicable(searchFilterState)) && isPredefinedFilterApplicable(predefinedFilters)) {
            setSearchTerm(predefinedFilters.searchParam);
            setFileTypes(predefinedFilters.fileTypes);
            setObjectType(predefinedFilters.objectType);
            setBreadcrumbPath(BreadcrumbPaths.FILTERED);
        }
    }, [isTemplatesInitialized]);

    const {
        data,
        isLoading: loadingStorageObjects,
        isError: loadingStorageObjectsError
    } = useGetSearchResult(isTemplatesInitialized, country, language, path, page, pageSize, sortType.toLowerCase(), sortOrder.toLowerCase(),
        searchTerm, fileId, fileTypes, noOfDays, getIsFavorite(), getIsPublic(), (objectType ?? '').toLowerCase());

    useEffect(() => {
        setPageCount(data?.totalPages ?? 0);
        setItemCountTotal(data?.totalCount ?? 0);
        setStorageObjects(data?.storageObjects ?? []);
        setFavoritesStorageObjects(data?.favoriteStorageObjectIds ?? []);
        setBreadcrumbs(data?.breadcrumbs ?? []);
        setParentOwnerRoles(data?.parentOwnerRoles ?? []);
        setParentRoles(data?.parentRoles ?? []);
        setParentLocales(data?.parentLocales ?? []);
        setPopulateError(true);
    }, [data]);

    useEffect(() => {
        if ((!isTemplatesInitialized) || (data?.totalCount === undefined) || (!data?.totalCount)) {
            return;
        }

        // Finds the item from the deep link in case the first attempt to find the item fails(query returns zero results)
        // This can be caused by isFavorite, isPublic, different user role set
        // The trigger of this condition is that the link contains instruction to popup file with id(property showItemDetails)
        if ((page > 1) && (data.totalCount === 0)) {
            setFileId(showItemDetails);
            setPage(1);
        }

        if ((!isAuthenticated) && (showItemDetails !== undefined) && showItemDetails) {
            setFileId(showItemDetails);
        }
    }, [isTemplatesInitialized, data?.totalCount, page, showItemDetails, isAuthenticated]);

    const {
        data: disclaimerData
    } = useGetDisclaimerData();

    useEffect(() => {
        if ((disclaimerData !== undefined) && disclaimerData) {
            setDisclaimerOptions(disclaimerData);
        }
    }, [disclaimerData]);

    const {existingLabelData} = useGetLabelData();

    const renderErrorDialog = (populate: boolean, headline: string | undefined, description: string | undefined) => {
        return <ErrorDialogue populate={populate}
                              headline={headline}
                              description={description}
                              onChange={(populated: boolean) => {
                                  setPopulateError(populated);
                                  setDialogError(undefined);
                              }}/>
    };

    const navigateToPreviousPage = () => {
        if (!isTrue(isFavorite)) {
            return;
        }

        if ((page > 1) && ((data?.totalPages ?? 0) > 1) && ((data?.pageSize ?? 0) > 0)
            && ((data?.totalCount ?? 0) > (data?.pageSize ?? 0))) {
            setPage(page - 1);
        }
    };

    const handleDeleteSearchParameter = (searchParam: string) => {
        if ((searchParam !== undefined) && (!isNullOrEmpty(searchParam))) {
            searchParams.delete(searchParam);
            setSearchParams(searchParams, {replace: true});
        }
    };

    const handleResetSearchParameters = () => {
        setShowItemDetails(undefined);
        setFileId(undefined);
        setSearchTerm(undefined);
        setFileTypes(undefined);
        setNoOfDays(undefined);
        setIsFavorite(undefined);
        setIsPublic(undefined);
        setObjectType(undefined);
        searchParams.forEach(key => searchParams.delete(key));
        setSearchParams(searchParams, {replace: true});
        setPath('/');
        setPage(1);
        setPageSize(defaultPageSize);
        setSortOrder(sortOderDefault);
        setLayoutView(layoutView);
    };

    const renderItems = () => {
        if (!(isVisibleComponent(DOWNLOAD_CENTER_ITEMS_VIEW, templatePropertySettings)
            && ((!isMobileView) || (isMobileView && isVisibleComponent(DOWNLOAD_CENTER_MOBILE_ITEMS_VIEW, templatePropertySettings))))) {
            return;
        }

        const handlePreview = (item: StorageObject) => {
            setShowPreview(item.id);
        };

        const handleItemClick = (item: StorageObject) => {
            let action = '';
            switch (item.objectType) {
                case ObjectType.FOLDER:
                    if (isMobileView) {
                        action = getDefaultValueOfComponent(ITEMS_VIEW_MOBILE_FOLDER_ON_CLICK_COMMAND_ACTION, templatePropertySettings);
                        if (isNullOrEmpty(action)) {
                            action = defaultItemsViewMobileFolderOnClickCommandAction;
                        }
                    } else {
                        action = getDefaultValueOfComponent(ITEMS_VIEW_FOLDER_ON_CLICK_COMMAND_ACTION, templatePropertySettings);
                        if (isNullOrEmpty(action)) {
                            action = defaultItemsViewFolderOnClickCommandAction;
                        }
                    }
                    break;
                case ObjectType.FILE:
                    if (isMobileView) {
                        action = getDefaultValueOfComponent(ITEMS_VIEW_MOBILE_FILE_ON_CLICK_COMMAND_ACTION, templatePropertySettings);
                        if (isNullOrEmpty(action)) {
                            action = defaultItemsViewMobileFileOnClickCommandAction;
                        }
                    } else {
                        action = getDefaultValueOfComponent(ITEMS_VIEW_FILE_ON_CLICK_COMMAND_ACTION, templatePropertySettings);
                        if (isNullOrEmpty(action)) {
                            action = defaultItemsViewFileOnClickCommandAction;
                        }
                    }
                    break;
                default:
                    break;
            }

            switch (action) {
                case ITEMS_VIEW_COMMAND_ACTION_NAVIGATE:
                    setPath(decodeURI(item.fullPath));
                    setPage(1);
                    layoutRef.current?.scrollIntoView({behavior: 'smooth'});
                    return;
                case ITEMS_VIEW_COMMAND_ACTION_EDIT:
                    handleEdit(item);
                    return;
                case ITEMS_VIEW_COMMAND_ACTION_DELETE:
                    setItemToDelete(item)
                    return;
                case ITEMS_VIEW_COMMAND_ACTION_FAVORITE:
                    handleFavorite(item);
                    return;
                case ITEMS_VIEW_COMMAND_ACTION_VIEW:
                    setShowItemDetails(item.id);
                    return;
                case ITEMS_VIEW_COMMAND_ACTION_PREVIEW:
                    handlePreview(item)
                    return;
                case ITEMS_VIEW_COMMAND_ACTION_COPY_URL:
                    handleCopyUrl(item)
                    return;
                case ITEMS_VIEW_COMMAND_ACTION_DOWNLOAD:
                    handleDownload(item);
                    return;
                default:
                    setShowItemDetails(item.id);
                    return;
            }
        };

        const handleEdit = (item: StorageObject) => {
            switch (item.objectType) {
                case ObjectType.FOLDER:
                    setFolderToEdit(item);
                    return;
                case ObjectType.FILE:
                    setFileToEdit(item);
                    return;
                default:
                    return;
            }
        };

        const handleDelete = (item: StorageObject) => {
            setItemToDelete(item);
        };

        const handleDetails = (item: StorageObject) => {
            setShowItemDetails(item.id);
        };

        if (loadingStorageObjectsError) {
            if (!validateSearchTerm(searchTerm)) {
                let errorData = getErrorDataValidationMessages(t('ERROR_SEARCH_PARAMETER_VALUE_CONSTRAINT_HEADLINE'), getSearchTermConstraintErrorMessage());
                return <ErrorDialogue populate={populateError}
                                      headline={errorData?.headline}
                                      description={errorData?.errorDescription}
                                      onChange={(populated: boolean) => setPopulateError(populated)}/>
            } else if ((data === undefined) || (!data)) {
                let urlLength = window.location.href.length;
                let validationMessages: ValidationMessage[] = [];
                if (urlLength > LENGTH_LIMIT_URL_QUERY_PARAMETER) {
                    validationMessages = getUrlLengthLimitConstraintErrorMessage(urlLength);
                }

                let errorData = getErrorDataValidationMessages(t('ERROR_LOADING_FAILED'), validationMessages);
                return <ErrorDialogue populate={populateError}
                                      headline={errorData?.headline}
                                      description={errorData?.errorDescription}
                                      onChange={(populated: boolean) => setPopulateError(populated)}/>
            } else {
                let errorData = getErrorDataValidationMessages(t('ERROR_LOADING_FAILED'), getGeneralErrorErrorMessage());
                return <ErrorDialogue populate={populateError}
                                      headline={errorData?.headline}
                                      description={errorData?.errorDescription}
                                      onChange={(populated: boolean) => setPopulateError(populated)}/>
            }
        } else if (loadingStorageObjects) {
            return <LoadingIndicator/>;
        } else if ((storageObjects === undefined) || (!storageObjects)) {
            let errorData = getErrorDataValidationMessages(t('ERROR_LOADING_FAILED'), getNoDataFoundErrorMessage());
            return <ErrorDialogue populate={populateError}
                                  headline={errorData?.headline}
                                  description={errorData?.errorDescription}
                                  onChange={(populated: boolean) => setPopulateError(populated)}/>
        }

        return <ItemsView templatePropertySettings={templatePropertySettings}
                          isMobileView={isMobileView}
                          isMobileResolution={isMobileResolution}
                          layoutView={getLayoutTypeByKey(layoutView)}
                          items={storageObjects}
                          favoriteItems={favoritesStorageObjects}
                          language={language}
                          defaultLocale={defaultLocale}
                          editMode={editMode}
                          publicOnlyAccess={publicOnlyAccess}
                          labelData={existingLabelData}
                          onEdit={(item) => handleEdit(item)}
                          onDelete={(item) => handleDelete(item)}
                          onDownload={(item) => handleDownload(item)}
                          onDetails={(item) => handleDetails(item)}
                          onFavorite={(item) => handleFavorite(item)}
                          onPreview={(item) => handlePreview(item)}
                          onCopyUrl={(item) => handleCopyUrl(item)}
                          onClick={(item) => handleItemClick(item)}/>;
    };

    const resetFileDownload = () => {
        setDisclaimerDialog(false);
        setDisclaimerWatermarkDialog(false);
        setFileToDownload(null);
    };

    /**
     * Attempts to download a file. Checks if a watermark needs to be added to the file on download.
     * Ask user to give consent and accept disclaimer data.
     * If Watermark service is NOT enabled - downloads the file, else sets a watermarked file for download and
     thus opens a warning that
     * the file will be watermarked on download which allows to confirm to proceed with download
     * @param item a storage object that represent a file to download
     */
    const handleDownload = (item: StorageObject) => {
        if ((item === undefined) || (!item)) {
            return;
        }

        let isSilentDownload = true;
        if (isWatermarkApplicableCheck(item.metadata.watermark)) {
            setFileToDownload(item);
            isSilentDownload = false;
        }

        if (config.DISCLAIMER_ENABLED && (!!item.metadata.disclaimer) && (item.metadata.disclaimer != NO_DISCLAIMER_KEY)
            && disclaimerOptions && (disclaimerOptions.length > 0)) {
            let selectedData: DisclaimerDTO[] = disclaimerOptions?.filter(filteredData => (filteredData.disclaimerId === item.metadata.disclaimer));
            if (selectedData && (selectedData.length > 0)) {
                setFileToDownload(item);
                isSilentDownload = false;
                if (item.metadata.disclaimer?.includes(WATERMARK)) {
                    setDisclaimerWatermarkDialog(true);
                } else {
                    setDisclaimerDialog(true);
                }
            }
        }

        if (isSilentDownload) {
            executeDownloadFile(item);
        }
    };

    const getCountryDataSource = (locales: string[] | undefined): DropdownOptionProps[] => {
        let countryDataSource: DropdownOptionProps[] = [];
        let localeItem: string[] = [];
        if (locales) {
            locales.map(locale => {
                if (locale) {
                    localeItem = locale.split('_');
                    if ((localeItem) && (localeItem.length >= 2)) {
                        let localeCountry = localeItem[1].toUpperCase();
                        let countryItem: DropdownOptionProps[] = countryResource.filter(country => country.value === localeCountry);
                        if (countryItem && countryItem.length > 0) {
                            let countryItemValue = {
                                name: countryItem[0].name,
                                value: localeCountry
                            } as DropdownOptionProps;
                            if (!countryDataSource.some(option => (option.value === countryItemValue.value))) {
                                countryDataSource.push(countryItemValue);
                            }
                        }
                    }
                }
            });
        }

        return countryDataSource;
    };

    const getLanguageDataSource = (locales: string[] | undefined): DropdownOptionProps[] => {
        let languageDataSource: DropdownOptionProps[] = [];
        let localeItem: string[] = [];
        if (locales) {
            locales.map(locale => {
                if (locale) {
                    localeItem = locale.split('_');
                    if ((localeItem) && (localeItem.length >= 2)) {
                        let localeLanguage = localeItem[0].toLowerCase();
                        let languageItem: DropdownOptionProps[] = languageResource.filter(language => language.value === localeLanguage);
                        if (languageItem && languageItem.length > 0) {
                            let languageItemValue = {
                                name: languageItem[0].name,
                                value: localeLanguage
                            } as DropdownOptionProps;
                            if (!languageDataSource.some(option => (option.value === languageItemValue.value))) {
                                languageDataSource.push(languageItemValue);
                            }
                        }
                    }
                }
            });
        }

        return languageDataSource;
    };

    const getLocaleDataSource = (locales: string[] | undefined): string[] => {
        let localeDataSource: string[] = [];
        let localeItem: string[] = [];
        if (locales) {
            locales.map(locale => {
                if (locale) {
                    localeItem = locale.split('_');
                    if ((localeItem) && (localeItem.length >= 2)) {
                        let localeItemValue = convertLocaleToPersistentValue(locale);
                        if ((!isNullOrEmpty(localeItemValue)) && (!localeDataSource.includes(localeItemValue))) {
                            localeDataSource.push(localeItemValue);
                        }
                    }
                }
            });
        }

        return localeDataSource;
    };

    const hideFormDetailsDialog = () => {
        setShowItemDetails(undefined);
        setFileId(undefined);
    };

    const hidePreviewDetailsDialog = () => {
        setShowPreview(undefined);
        setFileId(undefined);
    };

    const deleteFromDetailsDialog = (item: StorageObject) => {
        setItemToDelete(item);
        setShowItemDetails(undefined);
    };

    const handleCopyUrl = async (item: StorageObject) => {
        if (item && (!isNullOrEmpty(item.id)) && (!isNullOrEmpty(item.fullPath))) {
            let url = new URL(window.location.href);
            url.search = '';
            url.searchParams.set(PARAM_PATH, decodeURI(item.path));
            url.searchParams.set(PARAM_PAGE, '1');
            url.searchParams.set(PARAM_SORT, sortType);
            url.searchParams.set(PARAM_ORDER, sortOrder);
            url.searchParams.set(PARAM_SEARCH, decodeURI(getLabelNative(defaultLocale, getLabelEntryMapDefault(defaultLocale, item.labels)).name));
            url.searchParams.set(PARAM_FILE_ID, item.id);
            await navigator.clipboard.writeText(url.toString());
            alert(t('GENERAL_ALERT_COPY_URL_LABEL'));
        }
    };

    const renderItemDetailsDialog = () => {
        let itemId = showItemDetails;
        if ((itemId === undefined) || (isNullOrEmpty(itemId)) || (storageObjects.length === 0)) {
            return;
        }

        let item = storageObjects?.find((item) => (item.id === itemId)) as StorageObject;
        if ((item === undefined) || (!item)) {
            return;
        }

        switch (item.objectType) {
            case ObjectType.FOLDER:
                return (
                    <FolderDetailsDialog item={item}
                                         language={language}
                                         defaultLocale={defaultLocale}
                                         editMode={editMode}
                                         editAction={() => setFolderToEdit(item)}
                                         deleteAction={() => deleteFromDetailsDialog(item)}
                                         copyUrlAction={() => handleCopyUrl(item)}
                                         onClose={() => hideFormDetailsDialog()}/>
                );
            case ObjectType.FILE:
                return (
                    <FileDetailsDialog item={item}
                                       language={language}
                                       defaultLocale={defaultLocale}
                                       editMode={editMode}
                                       editAction={() => setFileToEdit(item)}
                                       deleteAction={() => deleteFromDetailsDialog(item)}
                                       downloadAction={() => handleDownload(item)}
                                       copyUrlAction={() => handleCopyUrl(item)}
                                       onClose={() => hideFormDetailsDialog()}/>
                );
            default:
                return;
        }
    };

    const renderPreviewDialog = () => {
        let itemId = showPreview;
        if ((itemId === undefined) || (isNullOrEmpty(itemId)) || (storageObjects.length === 0)) {
            return;
        }

        let item = storageObjects?.find((item) => (item.id === itemId)) as StorageObject;
        if ((item === undefined) || (!item)) {
            return;
        } else if (isFile(item.objectType)) {
            return (
                <PreviewDialog item={item}
                               language={language}
                               defaultLocale={defaultLocale}
                               editMode={editMode}
                               editAction={() => setFileToEdit(item)}
                               deleteAction={() => deleteFromDetailsDialog(item)}
                               downloadAction={() => handleDownload(item)}
                               onClose={() => hidePreviewDetailsDialog()}/>
            );
        }
    };

    const renderCreateFolderDialog = () => {
        return (
            createFolderModeActive && (
                <CreateEditFolderDialog item={folderToEdit}
                                        name={folderToEdit?.name ?? ''}
                                        breadcrumbs={breadcrumbs}
                                        currentPath={path}
                                        rolesDataSource={roleDataSource}
                                        parentOwnerRoles={parentOwnerRoles}
                                        parentRoles={parentRoles}
                                        parentLocales={parentLocales}
                                        language={language}
                                        defaultLocale={defaultLocale}
                                        onClose={() => setCreateFolderModeActive(false)}
                                        onSave={(storageObject, addMore) => {
                                            createFolder(getCreateFolderDTO(storageObject), addMore)
                                                .catch((error) => setDialogError({
                                                    headline: t('ERROR_FOLDER_CREATE_FAILED'),
                                                    errorDescription: setErrorDescription(error.response.data)
                                                }));
                                        }}
                />
            )
        );
    };

    const renderEditFolderDialog = () => {
        return (
            (!!folderToEdit) && (
                <CreateEditFolderDialog item={folderToEdit}
                                        name={folderToEdit.name}
                                        breadcrumbs={breadcrumbs}
                                        currentPath={path}
                                        rolesDataSource={roleDataSource}
                                        parentOwnerRoles={parentOwnerRoles}
                                        parentRoles={parentRoles}
                                        parentLocales={parentLocales}
                                        language={language}
                                        defaultLocale={defaultLocale}
                                        onClose={() => {
                                            setFolderToEdit(null);
                                        }}
                                        onSave={(storageObject, addMore) => {
                                            editFolder(getEditFolderDTO(storageObject))
                                                .catch((error) => setDialogError({
                                                    headline: t('ERROR_FOLDER_EDIT_FAILED'),
                                                    errorDescription: setErrorDescription(error.response.data)
                                                }))
                                                .then(() => {
                                                    if (addMore) {
                                                        setCreateFolderModeActive(true);
                                                    }
                                                });
                                        }}
                />
            )
        );
    };

    const renderUploadFileDialog = () => {
        return (
            uploadFileModeActive && (
                <UploadFileDialog item={fileToEdit}
                                  name={fileToEdit?.name ?? ''}
                                  breadcrumbs={breadcrumbs}
                                  currentPath={path}
                                  rolesDataSource={roleDataSource}
                                  parentOwnerRoles={parentOwnerRoles}
                                  parentRoles={parentRoles}
                                  parentLocales={parentLocales}
                                  language={language}
                                  defaultLocale={defaultLocale}
                                  disclaimerData={disclaimerOptions}
                                  labelData={existingLabelData}
                                  onClose={() => setUploadFileModeActive(false)}
                                  onSave={(storageObjectDTO, thumbnail, executeFileUpload, file, addMore) => {
                                      uploadFile(getUploadFileDTO(storageObjectDTO, thumbnail, executeFileUpload, file), addMore)
                                          .catch((error) => setDialogError({
                                              headline: t('ERROR_FILE_UPLOAD_FAILED'),
                                              errorDescription: setErrorDescription(error.response.data)
                                          }));
                                  }}
                />
            )
        );
    };

    const renderEditFileDialog = () => {
        return (
            (!!fileToEdit) && (
                <EditFileDialog item={fileToEdit}
                                name={fileToEdit.name}
                                breadcrumbs={breadcrumbs}
                                currentPath={path}
                                rolesDataSource={roleDataSource}
                                parentOwnerRoles={parentOwnerRoles}
                                parentRoles={parentRoles}
                                parentLocales={parentLocales}
                                language={language}
                                defaultLocale={defaultLocale}
                                disclaimerData={disclaimerOptions}
                                labelData={existingLabelData}
                                onClose={() => {
                                    setFileToEdit(null);
                                }}
                                onSave={(storageObjectDTO, thumbnail, addMore) => {
                                    editFile(getEditFileDTO(storageObjectDTO, thumbnail))
                                        .catch((error) => setDialogError({
                                            headline: t('ERROR_FILE_EDIT_FAILED'),
                                            errorDescription: setErrorDescription(error.response.data)
                                        })).then(() => {
                                        if (addMore) {
                                            setUploadFileModeActive(true);
                                        }
                                    });
                                }}
                />
            )
        );
    };

    const renderDeleteDialog = () => {
        return (
            ((!!itemToDelete) && (!headlessDeleteAction)) && (
                <DeleteItemDialog fileTitle={itemToDelete.name}
                                  countryDataSource={getCountryDataSource(Object.keys(itemToDelete.labels))}
                                  languageDataSource={getLanguageDataSource(Object.keys(itemToDelete.labels))}
                                  localeDataSource={getLocaleDataSource(Object.keys(itemToDelete.labels))}
                                  defaultLocale={defaultLocale}
                                  isCompleteToDelete={isCompleteToDelete}
                                  countriesToDelete={countriesToDelete}
                                  languagesToDelete={languagesToDelete}
                                  localesToDelete={localesToDelete}
                                  setIsCompleteToDelete={(isComplete: boolean) => setIsCompleteToDelete(isComplete)}
                                  setCountriesToDelete={(countriesToDelete: string[]) => setCountriesToDelete(countriesToDelete)}
                                  setLanguagesToDelete={(languagesToDelete: string[]) => setLanguagesToDelete(languagesToDelete)}
                                  setLocalesToDelete={(localesToDelete: string[]) => setLocalesToDelete(localesToDelete)}
                                  onCancel={() => cancelDeleteItem()}
                                  onConfirm={() => deleteItem()
                                      .catch((error) => setDialogError({
                                          headline: t('ERROR_DELETE_FAILED'),
                                          errorDescription: setErrorDescription(error.response.data)
                                      }))}/>
            )
        );
    };

    const getDisclaimerId = (item: StorageObject | null): string => {
        return (item && (item.metadata.disclaimer !== undefined) && (!isNullOrEmpty(item.metadata.disclaimer))) ? item.metadata.disclaimer : NO_DISCLAIMER_KEY;
    };

    const executeGiveConsent = async (language: string,
                                      disclaimerId: string,
                                      fileId: string | null | undefined,
                                      isConsentGiven: boolean) => {
        await giveConsent(language, disclaimerId, fileId, isConsentGiven)
            .catch((error) => setDialogError({
                headline: t('ERROR_CONSENT_GIVE_FAILED'),
                errorDescription: setErrorDescription(error.response.data)
            }));
    };

    // const executeRevokeConsent = async (language: string,
    //                                     disclaimerId: string,
    //                                     fileId: string | null | undefined) => {
    //     await revokeConsent(language, disclaimerId, fileId)
    //         .catch((error) => setDialogError({
    //             headline: t('ERROR_CONSENT_REVOKE_FAILED'),
    //             errorDescription: setErrorDescription(error.response.data)
    //         }));
    // };

    const renderDownloadFileDialog = () => {
        if ((fileToDownload === undefined) || (!fileToDownload) || ((!fileToDownload.metadata.watermark) && (!disclaimerDialog) && (!disclaimerWatermarkDialog))) {
            return;
        }

        let itemId = fileToDownload.id;
        if ((itemId === undefined) || (isNullOrEmpty(itemId))) {
            return;
        }

        let title = t('DOWNLOAD_WATERMARKED_FILE_TITLE');
        let headline = t('DOWNLOAD_WATERMARKED_FILE_HEADLINE');
        let infoText = t('DOWNLOAD_WATERMARKED_FILE_INFO_TEXT');
        let doNotExecuteGiveConsent = (isWatermarkApplicableCheck(fileToDownload.metadata.watermark) && ((!disclaimerDialog) && (!disclaimerWatermarkDialog))) as boolean;
        let disclaimerId = '';
        if (!doNotExecuteGiveConsent) {
            disclaimerId = getDisclaimerId(fileToDownload);
            let selectedDisclaimerOption = disclaimerOptions?.filter(filteredData => (filteredData.disclaimerId === disclaimerId));
            let isDisclaimerOptionFound = ((selectedDisclaimerOption !== undefined) && selectedDisclaimerOption && (selectedDisclaimerOption.length > 0)) as boolean;
            if (disclaimerDialog) {
                title = isDisclaimerOptionFound ? selectedDisclaimerOption[0].disclaimerType : NO_DISCLAIMER_KEY;
                headline = isDisclaimerOptionFound ? selectedDisclaimerOption[0].disclaimerText : NO_DISCLAIMER_KEY;
                infoText = '';
            } else if (disclaimerWatermarkDialog) {
                title = isDisclaimerOptionFound ? selectedDisclaimerOption[0].disclaimerType : t('DOWNLOAD_WATERMARKED_DISCLAIMED_FILE_TITLE');
                headline = isDisclaimerOptionFound ? selectedDisclaimerOption[0].disclaimerText : t('DOWNLOAD_WATERMARKED_DISCLAIMED_FILE_HEADLINE');
                infoText = t('DOWNLOAD_WATERMARKED_DISCLAIMED_FILE_INFO_TEXT');
            }
        }

        return (
            <DownloadFileDialog title={title}
                                headline={headline}
                                infoText={infoText}
                                onCancel={() => {
                                    if (doNotExecuteGiveConsent) {
                                        resetFileDownload();
                                    } else {
                                        executeGiveConsent(language, disclaimerId, itemId, false)
                                            .then(() => resetFileDownload());
                                    }
                                }}
                                onConfirm={() => {
                                    if (doNotExecuteGiveConsent) {
                                        executeDownloadFile(fileToDownload);
                                    } else {
                                        executeGiveConsent(language, disclaimerId, itemId, true)
                                            .then(() => executeDownloadFile(fileToDownload));
                                    }
                                }}/>
        );
    };

    const executeDownloadFile = (item: StorageObject | null) => {
        if ((item === undefined) || (!item)) {
            return;
        }

        let itemId = item.id;
        if ((itemId === undefined) || (isNullOrEmpty(itemId))) {
            return;
        }

        if (window.dataLayer) {
            sendEventToGTM(itemId, window.dataLayer[0].ciamId);
        }

        downloadFile(item).catch((error) => setDialogError({
            headline: t('ERROR_FILE_DOWNLOAD_FAILED'),
            errorDescription: setErrorDescription(error.response.data)
        }));

        resetFileDownload();
    };

    /**
     * This function send data from download service to Google Analytics when Google Tag Manager is integrated.
     * We can create customised datalayer event/variables on Google Analytics portal.
     * Please Refer
     https://inside-docupedia.bosch.com/confluence/display/DMAS/DXF+-+Google+Analytics+integration+with+Download+Service
     */
    const sendEventToGTM = (itemId: string, ciamId: unknown) => {
        if ((itemId === undefined) || (isNullOrEmpty(itemId))) {
            return;
        }

        if (window.dataLayer) {
            window.dataLayer = window.dataLayer || [];
            return window.dataLayer.push({
                    event: 'download_file',
                    download_file_id: itemId,
                    ciam_id: ciamId,
                    download_date: new Date(),
                }
            );
        }
    };

    const handleFavorite = async (item: StorageObject) => {
        if ((!isAuthenticated) || (item === undefined) || (!item)) {
            return;
        }

        await markAsFavorite({
            resourceId: item.id,
            isFavorite: favoritesStorageObjects.includes(item.id)
        }).catch((error) => setDialogError({
            headline: t('ERROR_FOLDER_EDIT_FAILED'),
            errorDescription: setErrorDescription(error.response.data)
        }));

        navigateToPreviousPage();
    };

    const renderProgressDialog = () => {
        return (
            showProgressDialog && (
                <Dialog id={generateIdentifier()}
                        open
                        modal
                        title={t('PROGRESS_DIALOG_TITLE')}>
                    <UploadProgressIndicator/>
                </Dialog>
            )
        );
    };

    if (isAuthenticating) {
        return (
            <Layout id={generateIdentifier()}>
                <LoadingIndicator/>
            </Layout>
        );
    }

    if (config.DLS_AUTHENTICATION_ACTIVE ? (!isAuthenticated) : false) {
        return (
            <Layout id={generateIdentifier()}>
                <ErrorHint type={NotificationType.INFO}
                           message={t('HINT_NOT_LOGGED_IN')}/>
            </Layout>
        );
    }

    return (
        <div id={generateIdentifier()}>
            <Layout id={generateIdentifier()}
                    ref={layoutRef}>
                {(isVisibleComponent(SEARCH_BAR, templatePropertySettings)
                        && ((!isMobileView) || (isMobileView && isVisibleComponent(SEARCH_BAR_MOBILE, templatePropertySettings)))) &&
                    <SearchBar templatePropertySettings={templatePropertySettings}
                               isMobileView={isMobileView}
                               isMobileResolution={isMobileResolution}
                               itemCount={itemCountTotal}
                               searchTerm={searchTerm}
                               recentlyAdded={noOfDays}
                               recentlyAddedDefault={recentlyAddedDefault}
                               isFavorite={getIsFavorite()}
                               isPublic={getIsPublic()}
                               sortType={sortType}
                               sortTypeDefault={sortTypeDefault}
                               sortOrder={sortOrder}
                               sortOderDefault={sortOderDefault}
                               objectType={objectType}
                               fileTypes={fileTypes}
                               publicOnlyAccess={publicOnlyAccess}
                               onFilterDisable={() => {
                                   setBreadcrumbPath(BreadcrumbPaths.HOME);
                                   handleResetSearchParameters();
                                   setPopulateError(true);
                               }}
                               onSearchTermChange={(searchTerm) => {
                                   if ((searchTerm !== undefined) && (!isNullOrEmpty(searchTerm))) {
                                       setPage(1);
                                       setSearchTerm(searchTerm);
                                       setBreadcrumbPath(BreadcrumbPaths.FILTERED);
                                   } else {
                                       setSearchTerm(undefined);
                                       let isValidSortOrder = validateSortOrder(sortType, sortTypeDefault, sortOrder, sortOderDefault);
                                       setBreadcrumbPath(getBreadcrumbState(searchTerm, noOfDays, getIsFavorite(), getIsPublic(), isValidSortOrder, objectType, fileTypes));
                                       handleDeleteSearchParameter(PARAM_SEARCH);
                                   }
                                   setFileId(undefined);
                                   setPopulateError(true);
                               }}
                               onFileTypesChange={(fileTypes) => {
                                   if ((fileTypes !== undefined) && fileTypes && (fileTypes.length > 0)) {
                                       setPage(1);
                                       setFileTypes(fileTypes);
                                       setBreadcrumbPath(BreadcrumbPaths.FILTERED);
                                   } else {
                                       setFileTypes(undefined);
                                       let isValidSortOrder = validateSortOrder(sortType, sortTypeDefault, sortOrder, sortOderDefault);
                                       setBreadcrumbPath(getBreadcrumbState(searchTerm, noOfDays, getIsFavorite(), getIsPublic(), isValidSortOrder, objectType, fileTypes));
                                       handleDeleteSearchParameter(PARAM_FILE_TYPES);
                                   }
                                   setFileId(undefined);
                                   setPopulateError(true);
                               }}
                               onRecentlyAddedChange={(noOfDays) => {
                                   if ((noOfDays !== undefined) && (noOfDays > 0)) {
                                       setPage(1);
                                       setNoOfDays(noOfDays);
                                       setBreadcrumbPath(BreadcrumbPaths.RECENTLY_ADDED);
                                   } else {
                                       setNoOfDays(undefined);
                                       let isValidSortOrder = validateSortOrder(sortType, sortTypeDefault, sortOrder, sortOderDefault);
                                       setBreadcrumbPath(getBreadcrumbState(searchTerm, 0, getIsFavorite(), getIsPublic(), isValidSortOrder, objectType, fileTypes));
                                       handleDeleteSearchParameter(PARAM_RECENTLY_ADDED);
                                   }
                                   setFileId(undefined);
                                   setPopulateError(true);
                               }}
                               onFavoriteChange={(isFavorite) => {
                                   if (isFavorite) {
                                       setPage(1);
                                       setIsFavorite(isFavorite.toString());
                                       setBreadcrumbPath(BreadcrumbPaths.FAVORITES);
                                   } else {
                                       setIsFavorite(undefined);
                                       let isValidSortOrder = validateSortOrder(sortType, sortTypeDefault, sortOrder, sortOderDefault);
                                       setBreadcrumbPath(getBreadcrumbState(searchTerm, noOfDays, isFavorite, getIsPublic(), isValidSortOrder, objectType, fileTypes));
                                       handleDeleteSearchParameter(PARAM_IS_FAVORITE);
                                   }
                                   setFileId(undefined);
                                   setPopulateError(true);
                               }}
                               onPublicChange={(isPublic) => {
                                   if (isPublic) {
                                       setPage(1);
                                       setIsPublic(isPublic.toString());
                                       setBreadcrumbPath(BreadcrumbPaths.PUBLIC_ACCESS);
                                   } else {
                                       setIsPublic(undefined);
                                       let isValidSortOrder = validateSortOrder(sortType, sortTypeDefault, sortOrder, sortOderDefault);
                                       setBreadcrumbPath(getBreadcrumbState(searchTerm, noOfDays, getIsFavorite(), isPublic, isValidSortOrder, objectType, fileTypes));
                                       handleDeleteSearchParameter(PARAM_IS_PUBLIC);
                                   }
                                   setFileId(undefined);
                                   setPopulateError(true);
                               }}
                               onSortItemsChange={(sortOrder) => {
                                   if (sortOrder !== sortOderDefault) {
                                       setSortOrder(sortOrder);
                                       setBreadcrumbPath(BreadcrumbPaths.FILTERED);
                                   } else {
                                       setSortOrder(sortOderDefault);
                                       let isValidSortOrder = validateSortOrder(sortType, sortTypeDefault, sortOrder, sortOderDefault);
                                       setBreadcrumbPath(getBreadcrumbState(searchTerm, noOfDays, getIsFavorite(), getIsPublic(), isValidSortOrder, objectType, fileTypes));
                                   }
                                   setFileId(undefined);
                                   setPopulateError(true);
                               }}
                               onObjectTypeChange={(objectType) => {
                                   if ((objectType !== undefined) && (!isNullOrEmpty(objectType)) && (TYPE_ALL !== objectType.toLowerCase())) {
                                       setObjectType(objectType);
                                       setBreadcrumbPath(BreadcrumbPaths.FILTERED);
                                   } else {
                                       setObjectType(undefined);
                                       let isValidSortOrder = validateSortOrder(sortType, sortTypeDefault, sortOrder, sortOderDefault);
                                       setBreadcrumbPath(getBreadcrumbState(searchTerm, noOfDays, getIsFavorite(), getIsPublic(), isValidSortOrder, objectType, fileTypes));
                                       handleDeleteSearchParameter(PARAM_TYPE);
                                   }
                                   setFileId(undefined);
                                   setPopulateError(true);
                               }}
                               mainAction={
                                   (editMode && (isVisibleComponent(DOWNLOAD_CENTER_MAIN_ACTION, templatePropertySettings)
                                       && ((!isMobileView) || (isMobileView && isVisibleComponent(DOWNLOAD_CENTER_MOBILE_MAIN_ACTION, templatePropertySettings))))) &&
                                   <AddItemMenu templatePropertySettings={templatePropertySettings}
                                                isMobileView={isMobileView}
                                                onCreateFolderClicked={() => setCreateFolderModeActive(true)}
                                                onUploadFileClicked={() => setUploadFileModeActive(true)}
                                   />
                               }/>
                }
                {(isVisibleComponent(SEARCH_BAR, templatePropertySettings)
                        && ((!isMobileView) || (isMobileView && isVisibleComponent(SEARCH_BAR_MOBILE, templatePropertySettings)))) &&
                    <hr id={generateIdentifier()}/>
                }
                {(isVisibleComponent(DOWNLOAD_CENTER_BREADCRUMB, templatePropertySettings)
                        && ((!isMobileView) || (isMobileView && isVisibleComponent(DOWNLOAD_CENTER_MOBILE_BREADCRUMB, templatePropertySettings)))) &&
                    <Breadcrumb breadcrumbs={breadcrumbs}
                                breadcrumbPath={breadcrumbPath}
                                onPathClicked={(path) => {
                                    setPath(decodeURI(path));
                                    setPage(1);
                                    setFileId(undefined);
                                    setPopulateError(true);
                                }}/>
                }
                <ItemsViewWrapper id={generateIdentifier()}>
                    {(isVisibleComponent(DOWNLOAD_CENTER_ITEMS_HEADER, templatePropertySettings)
                            && ((!isMobileView) || (isMobileView && isVisibleComponent(DOWNLOAD_CENTER_MOBILE_ITEMS_HEADER, templatePropertySettings)))) &&
                        <ItemsHeader templatePropertySettings={templatePropertySettings}
                                     isMobileView={isMobileView}
                                     isMobileResolution={isMobileResolution}
                                     page={page}
                                     pageCount={pageCount}
                                     itemCount={storageObjects.length}
                                     itemCountTotal={itemCountTotal}
                                     layoutView={getLayoutTypeByKey(layoutView)}
                                     pageSize={pageSize}
                                     pageSizeDataSource={pageSizeDataSource}
                                     onPageChange={setPage}
                                     onLayoutViewChange={handleLayoutViewChange}
                                     onPageSizeChange={(pageSize) => {
                                         setPage(1);
                                         if (pageSize < 1) {
                                             setPageSize(defaultPageSize);
                                         } else {
                                             setPageSize(pageSize);
                                         }
                                     }}/>
                    }
                    {(isVisibleComponent(DOWNLOAD_CENTER_ITEMS_VIEW, templatePropertySettings)
                        && ((!isMobileView) || (isMobileView && isVisibleComponent(DOWNLOAD_CENTER_MOBILE_ITEMS_VIEW, templatePropertySettings)))) && renderItems()}
                    {(isVisibleComponent(DOWNLOAD_CENTER_ITEMS_FOOTER, templatePropertySettings)
                            && ((!isMobileView) || (isMobileView && isVisibleComponent(DOWNLOAD_CENTER_MOBILE_ITEMS_FOOTER, templatePropertySettings)))) &&
                        <ItemsFooter templatePropertySettings={templatePropertySettings}
                                     isMobileView={isMobileView}
                                     isMobileResolution={isMobileResolution}
                                     page={page}
                                     pageCount={pageCount}
                                     onPageChange={setPage}/>
                    }
                </ItemsViewWrapper>
            </Layout>
            {renderItemDetailsDialog()}
            {renderPreviewDialog()}
            {renderCreateFolderDialog()}
            {renderEditFolderDialog()}
            {renderUploadFileDialog()}
            {renderEditFileDialog()}
            {renderDeleteDialog()}
            {renderProgressDialog()}
            {renderErrorDialog(!!dialogError, dialogError?.headline, dialogError?.errorDescription)}
            {renderDownloadFileDialog()}
        </div>
    );
};
